export { default } from './DocumentExtractionFieldsTab';
